/**
 * Fibo Search Pro - Page Redirect Handler
 * 
 * This script checks if a search term exactly matches a page title
 * and redirects the user to that page instead of showing search results.
 */
jQuery(document).ready(function($) {
    // Define the admin-ajax.php URL directly in the script
    var adminAjaxUrl = '/wp-admin/admin-ajax.php';
    $(document).on('fibosearch/show-suggestions', function(event, data) {
        if (typeof event.detail === 'object' && 
            event.detail.suggestions && 
            event.detail.suggestions.length === 0 &&
            event.detail.suggestions.redirect_url) {
            window.location.href = event.detail.suggestions.redirect_url;
        }
    });
    
    // Approach 2: Monitor all AJAX responses
    $(document).ajaxComplete(function(event, xhr, settings) {
        try {
            // Only process if this might be a Fibo search response
            if (settings.url && 
               (settings.url.includes('dgwt_wcas') || 
                settings.url.includes('fibo') || 
                settings.url.includes('wc-ajax'))) {
                
                // Check for empty search results
                var response = JSON.parse(xhr.responseText);
                if (response && 
                    typeof response.suggestions !== 'undefined' && 
                    Array.isArray(response.suggestions)) {
                    
                    // Get the search query from the form input
                    var searchQuery = $('.dgwt-wcas-search-input').val().trim();
                    
                    // If we have a search query but no results, check for page match
                    if (searchQuery && searchQuery.length >= 3) {
                        // Check for exact page title match
                        $.ajax({
                            url: adminAjaxUrl,  // Using hardcoded admin-ajax.php URL
                            type: 'POST',
                            data: {
                                action: 'metro_check_exact_page_match',
                                search_query: searchQuery
                            },
                            success: function(response) {
                                if (response.success && response.data && response.data.redirect_url) {
                                    window.location.href = response.data.redirect_url;
                                }
                            }
                        });
                    }
                }
            }
        } catch (e) {
            // Silent fail if response isn't valid JSON
            console.log('Error parsing Fibo Search response:', e);
        }
    });
    
    // Approach 3: Direct form submission handling
    $('.dgwt-wcas-search-form').on('submit', function(e) {
        var searchQuery = $(this).find('.dgwt-wcas-search-input').val().trim();
        
        if (searchQuery.length >= 3) {
            // First, check for page matches before form submission
            $.ajax({
                url: adminAjaxUrl,  // Using hardcoded admin-ajax.php URL
                type: 'POST',
                async: false, // Make this synchronous to allow redirect before form submission
                data: {
                    action: 'metro_check_exact_page_match',
                    search_query: searchQuery
                },
                success: function(response) {
                    if (response.success && response.data && response.data.redirect_url) {
                        e.preventDefault();
                        window.location.href = response.data.redirect_url;
                        return false;
                    }
                }
            });
        }
    });
    
    // Approach 4: Detect search button clicks and check manually
    $('.dgwt-wcas-search-submit').on('click', function() {
        var $form = $(this).closest('form');
        var searchQuery = $form.find('.dgwt-wcas-search-input').val().trim();
        
        if (searchQuery.length >= 3) {
            // Create a separate AJAX request to check for exact page matches
            $.ajax({
                url: adminAjaxUrl,  // Using hardcoded admin-ajax.php URL
                type: 'POST',
                data: {
                    action: 'metro_check_exact_page_match',
                    search_query: searchQuery
                },
                success: function(response) {
                    if (response.success && response.data && response.data.redirect_url) {
                        window.location.href = response.data.redirect_url;
                    }
                }
            });
        }
    });
});